/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Autofill_FailedInputs */

const en_directory_submit_autofill_failed = /** @type {(inputs: Directory_Submit_Autofill_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autofill failed. You can fill the form manually.`)
};

const zh_directory_submit_autofill_failed = /** @type {(inputs: Directory_Submit_Autofill_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autofill 失败，你也可以手动填写。`)
};

/**
* | output |
* | --- |
* | "Autofill failed. You can fill the form manually." |
*
* @param {Directory_Submit_Autofill_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_autofill_failed = /** @type {((inputs?: Directory_Submit_Autofill_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Autofill_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_autofill_failed(inputs)
	return zh_directory_submit_autofill_failed(inputs)
});
export { directory_submit_autofill_failed as "directory.submit.autofill_failed" }